import { useParams } from 'react-router-dom';

import { RewardsLearnContent } from '@components';

import './style.scss';

export function RewardsLearnPage() {
  const { accountUsername } = useParams<{ accountUsername: string }>();

  return (
    <div className="rewards-learn-page">
      <div className="rewards-learn-page__main">
        <RewardsLearnContent accountName={accountUsername} />
      </div>
    </div>
  );
}
